/**
 * K-12 districts domain — utility functions and shared types.
 *
 * Re-exports generated entity types under domain-friendly aliases plus
 * the typed adapters that bridge the Kubb-generated shapes to the
 * legacy props expected by `DECommonTable`, `DemographicsSection`, etc.
 *
 * The cross-domain adapters live here (rather than in component files)
 * so the casts are documented and centralized.
 */

import type { AddressInfo } from '../../models/restaurant'
import type { K12DistrictDetailNested } from '../generated/types/K12DistrictDetailNested'

// ── Domain entity type re-exports ───────────────────────────────────

export type { K12DistrictDetail } from '../generated/types/K12DistrictDetail'
export type { K12DistrictDetailNested } from '../generated/types/K12DistrictDetailNested'
export type { K12LabelValue } from '../generated/types/K12LabelValue'

// ── Typed adapters for legacy component props ───────────────────────

/**
 * Convert the generated `K12DistrictDetailNested.address_info` (a
 * `ZipCode` shape) into the legacy `AddressInfo` interface that
 * `DemographicsSection` accepts.
 *
 * `models/restaurant.AddressInfo` declares every demographic field as
 * required & non-null; the generated `ZipCode` correctly types them as
 * optional. `DemographicsSection` already defends against missing
 * fields with `field || 0`, so the runtime data is compatible. This
 * helper makes the type bridge explicit instead of forcing every
 * call site to repeat `as unknown as AddressInfo`.
 */
export function toLegacyAddressInfo(
  addressInfo: K12DistrictDetailNested['address_info'] | null | undefined
): AddressInfo | undefined {
  if (!addressInfo) return undefined
  return addressInfo as unknown as AddressInfo
}
